"use strict";
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.TokenClient = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _TokenRoutes = require("./TokenRoutes");
var _constants = require("./constants");
var _AuthCookies = require("./internals/AuthCookies");
var _TokenFetcher = require("./internals/TokenFetcher");
var _logger = require("./logger");
var _SessionTokenStorage = require("./storage/SessionTokenStorage");
var logger = _logger.mainLogger.createChild('TokenClient');
var TokenClient = /*#__PURE__*/ function() {
    function TokenClient(options) {
        _class_call_check(this, TokenClient);
        (0, _defineProperty2.default)(this, "options", void 0);
        (0, _defineProperty2.default)(this, "storage", void 0);
        (0, _defineProperty2.default)(this, "tokenConfiguration", void 0);
        (0, _defineProperty2.default)(this, "timeout", null);
        (0, _defineProperty2.default)(this, "isTimeoutSet", false);
        /**
     * Stored token in memory, access value from this.getTokenData()
     */ (0, _defineProperty2.default)(this, "_tokenData", null);
        // This is for backward compatibility
        // TODO: This is kind of sketchy - lets TokenClientOptions.url be a enum instead of plain string in next major release
        var providedUrlIsValid = Object.values(_TokenRoutes.TokenRoutes).includes(options.url);
        if (!providedUrlIsValid) {
            logger.warn("Provided options.url ".concat(options.url, " is not valid and will be deprecated in the next release of @ori/auth"));
            // eslint-disable-next-line no-param-reassign -- okay for this case
            options.url = _TokenRoutes.TokenRoutes.PUBLIC_ACCESS;
        }
        this.options = options;
        this.tokenConfiguration = providedUrlIsValid ? _constants.tokenConfigurationForTokenRoutes[this.options.url] : _constants.tokenConfigurationForTokenRoutes[_TokenRoutes.TokenRoutes.PUBLIC_ACCESS];
        var _this_options_storage;
        // TODO: in the future we probably will not support adding custom storage
        this.storage = (_this_options_storage = this.options.storage) !== null && _this_options_storage !== void 0 ? _this_options_storage : new _SessionTokenStorage.SessionTokenStorage(this.tokenConfiguration.sessionStorageKey);
    }
    _create_class(TokenClient, [
        {
            key: "bindTokenUpdated",
            value: function bindTokenUpdated(handler) {
                document.addEventListener(this.tokenConfiguration.eventName, handler);
                return this;
            }
        },
        {
            key: "unbindTokenUpdated",
            value: function unbindTokenUpdated(handler) {
                document.removeEventListener(this.tokenConfiguration.eventName, handler);
                return this;
            }
        },
        {
            key: "getToken",
            value: function getToken() {
                var _this = this;
                return _async_to_generator(function() {
                    var isTokenRefreshed;
                    return _ts_generator(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.refreshToken()
                                ];
                            case 1:
                                isTokenRefreshed = _state.sent();
                                return [
                                    2,
                                    isTokenRefreshed ? _this.getTokenData() : null
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "refreshToken",
            value: function refreshToken() {
                var _this = this;
                return _async_to_generator(function() {
                    var storageTokenData, newTokenData, error;
                    return _ts_generator(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                // Get real stored token data, lifetime of token is managed there (it won't return token even if it's expired)
                                storageTokenData = _this.storage.getToken();
                                if (!!storageTokenData) return [
                                    3,
                                    5
                                ];
                                // Clearing token data inside is necessary since storage returned empty and this instance should reflect that
                                _this.clearTokenData();
                                newTokenData = null;
                                // If this token client is configured for user token and
                                // user is not logged in then there is no need to fetch at all
                                if (_this.storage.isForUserToken() && !_AuthCookies.AuthCookies.hasAuthorizedUserValue()) {
                                    throw new Error('User is not logged so we cannot retrieve user token, skipping');
                                }
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    3,
                                    ,
                                    4
                                ]);
                                return [
                                    4,
                                    _this.requestToken()
                                ];
                            case 2:
                                newTokenData = _state.sent();
                                return [
                                    3,
                                    4
                                ];
                            case 3:
                                error = _state.sent();
                                throw new Error("Refreshing token failed, requesting token was not successful: ".concat(error.message));
                            case 4:
                                if (newTokenData) {
                                    _this.setTokenData(newTokenData);
                                } else {
                                    throw new Error('Could not obtain user or public token at all');
                                }
                                _state.label = 5;
                            case 5:
                                _this.setRefreshTimeout(_this.getTokenData());
                                return [
                                    2,
                                    true
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "requestToken",
            value: function requestToken() {
                var _this = this;
                return _async_to_generator(function() {
                    var error;
                    return _ts_generator(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                return [
                                    4,
                                    _TokenFetcher.TokenFetcher.fetch(_object_spread_props(_object_spread({}, _this.options.requestOptions), {
                                        url: _this.options.url
                                    }))
                                ];
                            case 1:
                                return [
                                    2,
                                    _state.sent()
                                ];
                            case 2:
                                error = _state.sent();
                                throw new Error("Token request has failed: ".concat(error));
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "setRefreshTimeout",
            value: function setRefreshTimeout(tokenData) {
                var _this = this;
                if (this.isTimeoutSet || !tokenData) {
                    return;
                }
                this.isTimeoutSet = true;
                if (this.timeout !== null) {
                    window.clearTimeout(this.timeout);
                }
                this.timeout = window.setTimeout(function() {
                    _this.isTimeoutSet = false;
                    void _this.refreshToken();
                }, this.getTokenRefreshTime(tokenData));
            }
        },
        {
            /**
   * Dispatches custom event with current token data on this instance, if no token data are present then its skipped
   */ key: "dispatchTokenUpdated",
            value: function dispatchTokenUpdated() {
                var tokenData = this.getTokenData();
                if (!tokenData) {
                    return;
                }
                var event = new CustomEvent(this.tokenConfiguration.eventName, {
                    detail: {
                        tokenData: tokenData
                    }
                });
                document.dispatchEvent(event);
            }
        },
        {
            /**
   * Loads token onto instance
   */ key: "getTokenData",
            value: function getTokenData() {
                var _this__tokenData;
                (_this__tokenData = this._tokenData) !== null && _this__tokenData !== void 0 ? _this__tokenData : this._tokenData = this.storage.getToken();
                return this._tokenData;
            }
        },
        {
            /**
   * Clears token from instance and storage
   */ key: "clearTokenData",
            value: function clearTokenData() {
                this._tokenData = null;
                this.storage.token.remove();
                return this;
            }
        },
        {
            /**
   * Sets new token data on instance and saves it to storage
   */ key: "setTokenData",
            value: function setTokenData(tokenData) {
                this._tokenData = tokenData;
                // set token and add User id if not exist in data
                this.storage.setToken(tokenData);
                this.dispatchTokenUpdated();
                return this;
            }
        },
        {
            key: "getTokenRefreshTime",
            value: function getTokenRefreshTime(tokenData) {
                var expirationDate = Date.parse(tokenData.ExpirationDate);
                var currentDate = Date.now();
                var timeToRefresh = expirationDate - currentDate;
                if (timeToRefresh <= TokenClient.TOKEN_REQUEST_INTERVAL) {
                    timeToRefresh = 0;
                }
                return timeToRefresh;
            }
        }
    ]);
    return TokenClient;
}();
exports.TokenClient = TokenClient;
(0, _defineProperty2.default)(TokenClient, "TOKEN_REQUEST_INTERVAL", 30000); //# sourceMappingURL=TokenClient.js.map
